import { render } from "./multicolumnAccount.vue?vue&type=template&id=4f4099b0&scoped=true"
import script from "./multicolumnAccount.vue?vue&type=script&lang=js"
export * from "./multicolumnAccount.vue?vue&type=script&lang=js"

import "./multicolumnAccount.vue?vue&type=style&index=0&id=4f4099b0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4099b0"]])

export default __exports__